import { useEffect, useState } from "react";
import { Spinner } from "../../AbstractElements";

const RedirectLoader = () => {
  const [counter, setCounter] = useState(3); // Set the initial countdown time
  const appLink = "app://open.my.app"; // Use the correct deep link

  useEffect(() => {
    // Only start the timer if the counter is greater than 0
    if (counter > 0) {
      const timer = setInterval(() => {
        setCounter((prevCounter) => (prevCounter > 0 ? prevCounter - 1 : 0)); // Decrease counter but don't go below 0
      }, 1000);

      return () => clearInterval(timer); // Clear the interval when the component unmounts
    }

    // Redirect to the app when the counter reaches 0
    if (counter === 0) {
      window.location.href = appLink; // Automatically redirect after 3 seconds
    }
  }, [counter, appLink]);

  const handleRedirect = () => {
    window.location.href = appLink; // Manual redirect on button click
  };

  return (
    <div
      className="loader-box"
      style={{
        height: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
      }}
    >
      <h3>Redirecting...</h3>
      <Spinner
        attrSpinner={{
          className: "loader-3",
          style: {
            width: "50px",
            height: "50px",
            borderColor: "#52A31E",
            borderBottomColor: "transparent",
            borderWidth: 5,
          },
        }}
      />

      {/* Only show the countdown if counter is greater than 0 */}
      {/* {counter > 0 && ( */}
      <p style={{ margin: "20px 10px", fontSize: 15 }}>
        You will be redirected to the Megacabs Partner App in {counter} second
        {counter !== 1 ? "s" : ""}.
      </p>
      {/* )} */}

      <p style={{ marginTop: "8px" }}>
        If you're not redirected,{" "}
        <button
          onClick={handleRedirect}
          style={{
            color: "#52A31E",
            background: "none",
            border: "none",
            textDecoration: "underline",
            cursor: "pointer",
          }}
        >
          click here
        </button>
        .
      </p>
    </div>
  );
};

export default RedirectLoader;
